// extracted by mini-css-extract-plugin
export default {"autocomplete":"styles_autocomplete__Yr8vV","orgPhoto":"styles_org-photo__6CHzI"};